import { z } from 'zod';
import { AftermarketProductCategory, MarkupType } from '@trnsact/trnsact-shared-types';

export const createCustomProductSchema = z.object({
  cost: z.number().min(0),
  retailPrice: z.number().min(0),
  description: z.string().max(300).trim(),
  name: z.string().min(3).max(100).trim(),
  type: z.object({
    label: z.string(),
    value: z.nativeEnum(AftermarketProductCategory),
  }),
  vendor: z.object(
    {
      label: z.string(),
      value: z.string().uuid(),
    },
    { message: 'Field required' }
  ),
  markup: z.object({
    value: z.number().min(0),
    type: z.nativeEnum(MarkupType),
  }),
});
